import { Card, CardActionArea, Link, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { LazyContent } from 'evee-ui-common/components/base';
import { formatPriceNumber } from 'evee-ui-common/utils';

import styles from './styles';

const ModelCard = ({ name, index, price, thumbnail, searchQuery, loading, classes, ...rest }) => {
  const skeletonJsx = <Skeleton variant="rect" height="150px" style={{ marginLeft: '8px' }} />;

  const cardJsx = (
    <Link to={`/search?${searchQuery}`} underline="none" component={NavLink}>
      <Card elevation={0} {...rest}>
        <CardActionArea className={classes.actionArea}>
          {/* SEO (LCP) issue workaround */}
          {index === 0 ? (
            <img src={thumbnail} alt={`${name} available for rent on evee`} className={classes.image} />
          ) : (
            <LazyContent>
              <img src={thumbnail} alt={`${name} available for rent on evee`} className={classes.image} />
            </LazyContent>
          )}
        </CardActionArea>
        <Typography variant="h6" style={{ marginTop: '16px' }}>
          {name}
        </Typography>
        {price > 0 && (
          <Typography color="textSecondary">from {formatPriceNumber(price)}/day</Typography>
        )}
      </Card>
    </Link>
  );

  return loading ? skeletonJsx : cardJsx;
};

ModelCard.propTypes = {
  name: PropTypes.string,
  index: PropTypes.number,
  price: PropTypes.number,
  thumbnail: PropTypes.string,
  searchQuery: PropTypes.string,
  loading: PropTypes.bool,
  classes: PropTypes.shape({
    image: PropTypes.string.isRequired,
    actionArea: PropTypes.string.isRequired,
  }).isRequired,
};
ModelCard.defaultProps = {
  name: '',
  price: 0,
  thumbnail: '',
  searchQuery: '',
  loading: false,
};

export default withStyles(styles)(ModelCard);
